import { Link } from "react-router";
import { appPaths } from "../../../shared/routing/appPaths";
import { parseContentAddress } from "../../../shared/references/contentReferences";
import { useDocumentLabel } from "../../sources";

/** Resolve the name at the pinned version, including the segment's full path; "Document" until it is read, never the
 * document's ID, as the app names a document (`useDocumentLabel`). */
export default function ThreadSubjectLink({ subject, link = true }: { subject: string; link?: boolean }) {
  const address = parseContentAddress(subject);
  const version = address?.document.version ?? null;
  const label = useDocumentLabel(address === null || version === null ? null : { documentId: address.document.documentId, version });
  if (address === null) return null;
  const text = `${label}${address.segmentPath === null ? "" : ` #${address.segmentPath}`}`;
  return link ? <Link className="app-link app-link-cue-away block text-sm" to={appPaths.sourceDocument(address.document, address.segmentPath)}>{text}</Link> : <span className="app-text-muted block truncate text-xs" title={text}>{text}</span>;
}
